// Mock data for eco-friendly products website

export const heroData = {
  title: "Sustainable Solutions for a Greener Tomorrow",
  subtitle: "Premium biodegradable bags and bamboo products for eco-conscious businesses and individuals",
  cta: {
    primary: "Explore Products",
    secondary: "Contact Us"
  },
  image: "https://images.unsplash.com/photo-1542601906990-b4d3fb778b09"
};

export const features = [
{
  id: 1,
  title: "100% Biodegradable Bags",
  description: "Our bags decompose naturally within 180 days, leaving zero harmful residue. Perfect for retailers, hospitals, and eco-conscious businesses.",
  icon: "Leaf",
  image: "https://images.unsplash.com/photo-1597942524158-76a19366f4f7"
},
{
  id: 2,
  title: "Premium Bamboo Products",
  description: "Sustainable bamboo alternatives for everyday use. From utensils to home decor, our products combine durability with environmental responsibility.",
  icon: "TreePine",
  image: "https://images.unsplash.com/photo-1656411363355-808151c00f79"
},
{
  id: 3,
  title: "Carbon Neutral Production",
  description: "Our manufacturing process is designed to minimize carbon footprint. We offset 100% of our emissions through verified environmental projects.",
  icon: "Sprout",
  image: "https://images.unsplash.com/photo-1513836279014-a89f7a76ae86"
},
{
  id: 4,
  title: "Bulk Orders Welcome",
  description: "Special pricing for retailers, hospitals, and corporate clients. Customizable packaging options available for large-scale orders.",
  icon: "Package",
  image: "https://images.pexels.com/photos/18282623/pexels-photo-18282623.jpeg"
},
{
  id: 5,
  title: "Quality Certified",
  description: "All products meet international biodegradability and safety standards. Third-party tested and certified for your peace of mind.",
  icon: "Award",
  image: "https://images.unsplash.com/photo-1604564841521-a87b82cd3c22"
},
{
  id: 6,
  title: "Fast Delivery",
  description: "Reliable shipping to businesses and individuals nationwide. Track your order from our facility to your doorstep.",
  icon: "Truck",
  image: "https://images.unsplash.com/photo-1675116731363-c17d957f3444"
}];


export const testimonials = [
{
  id: 1,
  name: "Anita Singh",
  role: "Procurement Manager, City General Hospital",
  content: "We've switched entirely to these biodegradable bags for medical waste. The quality is exceptional, and we're proud to reduce our environmental impact.",
  rating: 5,
  avatar: "AS"
},
{
  id: 2,
  name: "Rakesh Kumar",
  role: "Owner, GreenMart Retail Chain",
  content: "Our customers love that we offer biodegradable bags. The bulk pricing is competitive, and the products are truly eco-friendly unlike many alternatives.",
  rating: 5,
  avatar: "RK"
},
{
  id: 3,
  name: "Priya Sharma",
  role: "Sustainability Director, TechCorp Inc.",
  content: "The bamboo products for our office have been a hit. From cutlery to desk organizers, everything is well-made and aligns with our green initiatives.",
  rating: 5,
  avatar: "PS"
},
{
  id: 4,
  name: "David Williams",
  role: "Restaurant Owner",
  content: "Switched to bamboo utensils and biodegradable takeout bags. Our eco-conscious customers appreciate it, and the products hold up great under use.",
  rating: 5,
  avatar: "DW"
}];


export const faqs = [
{
  id: 1,
  question: "How long does it take for the bags to decompose?",
  answer: "Our biodegradable bags decompose completely within 180 days in composting conditions. In natural environments, they break down within 12-18 months, unlike traditional plastic which can take 500+ years."
},
{
  id: 2,
  question: "Are your products suitable for food contact?",
  answer: "Yes! Our biodegradable bags and bamboo products are food-safe and certified for direct food contact. They meet FDA and international food safety standards."
},
{
  id: 3,
  question: "What is the minimum order quantity for bulk purchases?",
  answer: "For retailers and businesses, our minimum bulk order is 1,000 units for biodegradable bags and 500 units for bamboo products. We offer tiered pricing with significant discounts for larger orders."
},
{
  id: 4,
  question: "Can you customize products with our company logo?",
  answer: "Absolutely! We offer custom printing and branding on bulk orders. Contact our team with your requirements, and we'll provide options for eco-friendly inks and printing methods."
},
{
  id: 5,
  question: "What makes bamboo better than plastic alternatives?",
  answer: "Bamboo grows incredibly fast (up to 3 feet per day), requires no pesticides, and is naturally antimicrobial. It's stronger than many hardwoods, fully biodegradable, and sequesters carbon as it grows."
},
{
  id: 6,
  question: "Do you ship internationally?",
  answer: "Currently, we ship across the United States and Canada. We're expanding our international shipping capabilities. Contact us for specific country availability and shipping rates."
},
{
  id: 7,
  question: "What certifications do your products have?",
  answer: "Our products are certified by: ASTM D6400 (compostability), BPI (Biodegradable Products Institute), FDA (food safety), and FSC (Forest Stewardship Council) for sustainable sourcing."
},
{
  id: 8,
  question: "How should I store biodegradable bags?",
  answer: "Store in a cool, dry place away from direct sunlight. When stored properly, our bags maintain their integrity for 12-24 months. Once exposed to moisture and microbes, the biodegradation process begins."
}];


export const contactInfo = {
  email: "info@vmacglobal.in",
  phone: "+91 8147762223",
  address: "VMAC Global Private Limited, India",
  companyName: "VMAC Global Private Limited"
};

// Form submission mock
export const submitContactForm = async (formData) => {
  // Simulate API call
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("Contact form submitted:", formData);
      resolve({ success: true, message: "Thank you! We'll get back to you within 24 hours." });
    }, 1000);
  });
};